import { ReactElement } from "react";

import { BulkCounts, BulkMode } from "../types";

interface BulkSummaryProps {
  counts: BulkCounts;
  mode: BulkMode;
}

const show = (value?: number): string =>
  typeof value === "number" ? value.toLocaleString("en-US") : "—";

/**
 * The run's counters. `Inserted` only appears after execute, because validate
 * is read-only and inserts nothing.
 */
const BulkSummary: React.FC<BulkSummaryProps> = ({
  counts,
  mode,
}): ReactElement => (
  <div className="stats">
    <div className="stat">
      <label>Total rows</label>
      <strong>{show(counts.total)}</strong>
    </div>
    <div className="stat is-valid">
      <label>Valid records</label>
      <strong>{show(counts.valid)}</strong>
    </div>
    <div className="stat is-excluded">
      <label>Excluded</label>
      <strong>{show(counts.excluded)}</strong>
    </div>
    {mode === "execute" && (
      <div className="stat is-inserted">
        <label>Inserted</label>
        <strong>{show(counts.inserted)}</strong>
      </div>
    )}
  </div>
);

export default BulkSummary;
